export const initialState = {
  todoList: [{ id: 1001, text: "What happened to Monday?", isChecked: true }],
  addTodo: () => {},
  removeTodo: () => {},
  toggleChecked: () => {},
  setText: () => {},
  filterByStatus: () => [],
  changeFilterToken: () => {},
};
